import api from '@/api';
import { API_BASE_URL } from '..';
import { MatrixSettingsInterface } from './ReportSettings.types';

const CONTROLLER_URL = `${API_BASE_URL}/matrices-report-settings`;

export async function getReportSettings(): Promise<MatrixSettingsInterface> {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, {})) as unknown;

  return result as MatrixSettingsInterface;
}

export async function updateReportSettings({
  id,
  ...obj
}: MatrixSettingsInterface): Promise<MatrixSettingsInterface> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}`,
    obj,
    null,
  )) as unknown;

  return result as MatrixSettingsInterface;
}
